import { ElementType, Suspense } from 'react';

// project import
import { CircularLoaderProgress, LinearLoaderProgress } from './Loaders';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

export const LinearLoadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LinearLoaderProgress />}>
      <Component {...props} />
    </Suspense>
  );

  export const CircularLoadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<CircularLoaderProgress />}>
      <Component {...props} />
    </Suspense>
  );


// export default Loadable;
